/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Zeeshan Mehdi",
  title: "Hi all, I'm Zeeshan",
  subTitle: emoji(
    "A passionate Mobile Developer 🚀 having experience of building mobile applications for range of different domains"
  ),
  resumeLink:
    "https://www.icloud.com/iclouddrive/023qtEaFmXUXTaz1fohHxN-Vg#Zeeshan's_cv", // Set to empty to hide the button
  webLink: "https://zeeshan-mehdi.github.io/portfolio/", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/zeeshan-mehdi",
  linkedin: "https://www.linkedin.com/in/zeeshan-mehdi-a2a267b3/",
  gmail: "zeeshan_mehdi@icloud.com",
  gitlab: "https://gitlab.com/zeeshan-mehdi",
  // facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://medium.com/@zeeshanmehdi18",
  stackoverflow: "https://stackoverflow.com/users/7310240/zeeshan-mehdi",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Mobile Developer, want to be the best in the field",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for applications"
    ),
    emoji("⚡ Flutter and React Native Cross Platform Mobile Applications Development "),
    emoji(
      "⚡ Integration of third party services such as Firebase/GCP/Azure/AWS / Digital Ocean/Restful API"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },

    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "flutter",
      fontAwesomeClassname: "fab fa-flutter"
    },
    {
      skillName: "react-native",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "android",
      fontAwesomeClassname: "fab fa-android"
    },

    {
      skillName: "IOS",
      fontAwesomeClassname: "fab fa-app-store-ios"
    },


    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Hochschule Hof",
      logo: require("./assets/images/hochschule.png"),
      subHeader: "Master of Software Engineering for Industrial Applications",
      duration: "March 2022 - April 2024",
      desc: "Building Strong foundation of Software Engineering",
      descBullets: [

      ]
    },
    {
      schoolName: "University of Engineering and Technology",
      logo: require("./assets/images/uet.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2016 - Sept 2020",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems,OOP,Networking, AI ...",
      descBullets: []
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Flutter", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "React Native",
      progressPercentage: "90%"
    },
    {
      Stack: "Android",
      progressPercentage: "90%"
    },
    {
      Stack: "IOS",
      progressPercentage: "70%"
    },
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Mobile App Developer",
      company: "OwlConcepts",
      companylogo: require("./assets/images/owl.jpeg"),
      date: "Jan 2020 - Jan 2022",
      desc: "Designing, Development and Testing of Cross Platform Applications "
    },
    {
      role: "Android Developer",
      company: "Techniax Solutions",
      companylogo: require("./assets/images/techniax.png"),
      date: "Jan 2019 – Dec 2019",
      desc: "I was responsible for working on application development, unit testing, and Integration testing ",
      descBullets: [
      ]
    },

    {
      role: "Android Intern",
      company: "Sir Syed Institute of Technology",
      companylogo: require("./assets/images/case.png"),
      date: "Feb 2018 - Aug 2018",
      desc: "Active Role in development of Go Cleaner App for Android available on Google Play"
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

//

const bigProjects = {
  title: "Few Projects",
  subtitle: "SOME PROJECTS THAT I DID, MOSTLY ARE ANDROID AND IOS PROJECTS",
  projects: [

    {
      image: require("./assets/images/mt-guru.webp"),
      projectName: "My Transit Guru ",
      projectDesc: "Public transport analytics application for sydney based transport system",
      footerLink: [
        {
          name: "Check on Appstore",
          url: "https://apps.apple.com/pk/app/my-transit-guru/id1567199781"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/im.webp"),
      projectName: "Installment Mart",
      projectDesc: "Installment Mart App is Pakistans’ first and only online installment marketplace. Here you can access and make contact with thousands of buyers and sellers in your area; with only a few taps on your mobile screen",
      footerLink: [
        {
          name: "Check on Google Play",
          url: "https://play.google.com/store/apps/details?id=com.installmentmart&hl=en&gl=US"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/hirz.webp"),
      projectName: "Hirz App",
      projectDesc: "Hirz App is all about preserving the different modes of Qu'ran recitation, all linked to the Prophet",
      footerLink: [
        {
          name: "Check on Appstore",
          url: "https://apps.apple.com/at/app/hirz-app/id1540751597"
        }
      ]
    },
    {
      image: require("./assets/images/go-cleaner.webp"),
      projectName: "Go Cleaner",
      projectDesc: "Phone Cleaner Go is an android mobile phone cache cleaner, speed booster and memory booster. Arming with CPU cooler, Phone cleaner can optimize the phone with the help of battery saver, super cleaner and power clean",
      footerLink: [
        {
          name: "Check On Google Play",
          url: "https://play.google.com/store/apps/details?id=com.technogic.gocleanermaster&hl=en&gl=US"
        }
      ]
    },
    {
      image: require("./assets/images/faves.webp"),
      projectName: "Faves.Gift",
      projectDesc: "Never send a gift that someone doesn’t want again. No more scrolling through old messages trying to remember what your friend likes or what you last talked about",
      footerLink: [
        {
          name: "Check On Appstore",
          url: "https://apps.apple.com/lt/app/faves-gift/id1582680004?platform=iphone"
        }
      ]
    },

    {
      image: require("./assets/images/darhamad.webp"),
      projectName: "Darhamad",
      projectDesc: "A Luxury Niche Fragrance By Dar Hamad Fragrance. Kuwait",
      footerLink: [
        {
          name: "Check On Appstore",
          url: "https://apps.apple.com/us/app/id1531690034"
        }
      ]
    },
    {
      image: require("./assets/images/ghosia.webp"),
      projectName: "Ghosia Maintenance",
      projectDesc: "Ghosia Maintenance is all about ac maintenance & repair, electrical work and plumbing.",
      footerLink: [
        {
          name: "Check On Playstore",
          url: "https://play.google.com/store/apps/details?id=com.trytch.workeronline"
        }
      ]
    },
    {
      image: require("./assets/images/multok.png"),
      projectName: "Multok",
      projectDesc: "Its a children application some what similar to youtube for kids but localized for Ukrane",
      footerLink: [
        {
          name: "Check Design On Figma",
          url: "https://www.figma.com/file/1cBagCRJnhPLobK4Hy4XQi/multok.APP?node-id=87%3A2898"
        }
      ]
    }



  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        { name: "Certification", url: "" },
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+49-17635904971",
  email_address: "zeeshan_mehdi@icloud.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
